var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column justify-content-center"},[_c('h4',{staticClass:"text-center font-weight-bold"},[_vm._v(" Deseja tirar uma dúvida ou fazer uma cotação? ")]),_c('a',{staticClass:"btn button-yellow snip-button cta-button mt-2 px-3",attrs:{"href":"#pageform"}},[_vm._v("Fale conosco")])])
}]

export { render, staticRenderFns }